<template>
    <div class="explanation">
        <design-2021-apprentice-display-html-component
            class="explanation-text"
            v-if="partIn.isExplanationText()"
            :html-content="partIn.text?.value"></design-2021-apprentice-display-html-component>

        <div
            class="explanation-images"
            v-if="partIn.isExplanationImage()">
            <LightBox
                :ref="`lightbox-${partIn.id}`"
                :media="media(partIn.part_files)"
                :showLightBox="false">
            </LightBox>

            <div
                class="images imagescontain"
                v-if="partIn.part_files.length == 1">
                <img
                    class="explanation-image objectcontain"
                    v-for="(file, fileIndex) of partIn.part_files.slice(0, 8)"
                    :key="`image--${file.id}`"
                    :src="file.file.public_path"
                    @click="openImageLightBox(partIn.id, fileIndex)" />
            </div>
            <div
                class="images"
                v-else>
                <img
                    class="explanation-image"
                    v-for="(file, fileIndex) of partIn.part_files.slice(0, 8)"
                    :key="`image--${file.id}`"
                    :src="file.file.public_path"
                    @click="openImageLightBox(partIn.id, fileIndex)" />
            </div>

            <span
                class="remaining-images"
                v-if="partIn.part_files.length > 8"
                @click="openImageLightBox(partIn.id, 7)">
                {{ partIn.part_files.length - 8 }}+
            </span>
        </div>

        <div
            class="explanation-video-file"
            v-if="partIn.isExplanationVideo()">
            <design-2021-apprentice-video-player-component
                class="video-file"
                v-for="file of partIn.part_files"
                :options="getVideoOptions(file.file)"
                :key="file.id">
            </design-2021-apprentice-video-player-component>
        </div>

        <div
            class="explanation-attachment-files"
            v-if="partIn.isExplanationAttachment()">
            <div class="component-title">
                <h5 class="title">Bijlagen</h5>
            </div>
            <div
                class="explanation-attachment-file file"
                v-for="file of partIn.part_files"
                :key="file.id">
                <div
                    class="icon icon-type"
                    :class="getFileType(file.file.extension)"></div>
                <b-button
                    class="btn-preview-attachment-file"
                    v-if="common.canPreviewFile(file.file.extension)"
                    variant="link"
                    @click="previewFile(file.file)">
                    {{ file.file.full_name }}
                    <div class="file-size text-muted">
                        {{ file.file.size }}
                    </div>
                </b-button>

                <div
                    class="title"
                    v-else>
                    {{ file.file.full_name }}
                    <div class="file-size text-muted">
                        {{ file.file.size }}
                    </div>
                </div>
                <div class="download-file">
                    <b-button
                        class="btn-download btn-file-download"
                        variant="primary-icon-only"
                        :href="file.file.public_path"
                        :download="file.file.public_path"
                        target="_blank">
                    </b-button>
                </div>
            </div>
        </div>

        <div
            class="explanation-video-link"
            v-if="partIn.isExplanationYoutubeLink()">
            <design-2021-apprentice-video-link-player-component
                :options="playerOptions"
                :src="sourceUrl">
            </design-2021-apprentice-video-link-player-component>
        </div>

        <div
            class="explanation-audio-files"
            v-if="partIn.isExplanationAudio()">
            <div class="component-title">
                <h5 class="title">Audio bestanden</h5>
            </div>
            <div
                class="explanation-audio-file file"
                v-for="file of partIn.part_files"
                :key="file.id">
                <audio
                    controls
                    :ref="`audio-file-${file.id}`">
                    <source
                        :src="file.file.public_path"
                        type="audio/mpeg" />
                    Your browser does not support the audio element.
                </audio>
            </div>
        </div>
    </div>
</template>

<script>
import LightBox from 'vue-image-lightbox';
require('vue-image-lightbox/dist/vue-image-lightbox.min.css');

export default {
    name: 'design-2021-assignment-show-explanation-part-component',
    data() {
        return {
            height: '450px',
            playerOptions: {
                responsive: true,
                autoplay: false,
                controls: true,
            },
            sourceUrl: this.partIn?.video_link?.value ?? '',
        };
    },
    components: {
        LightBox,
    },
    props: ['partIn'],
    methods: {
        media(files) {
            return files
                .filter((file) => !!file.file)
                .map((file) => {
                    return {
                        thumb: file.file.path,
                        src: file.file.path,
                        caption: file.name,
                    };
                });
        },
        openImageLightBox(partId, index) {
            const name = `lightbox-${partId}`;
            this.$refs[name].showImage(index);
        },
        getVideoOptions(file) {
            // todo check for unsuported video files
            let ext = file.extension;
            if (ext === 'ogv') {
                ext = 'ogg';
            }
            if (ext === 'mov' || ext === 'MOV') {
                ext = 'mp4';
            }

            return {
                responsive: true,
                autoplay: false,
                controls: true,
                sources: [
                    {
                        type: 'video/' + ext,
                        src: file.public_path,
                    },
                ],
            };
        },

        getFileType(filetype) {
            switch (filetype) {
                case 'jpeg':
                case 'jpg':
                case 'png':
                case 'jif':
                case 'jfif':
                case 'gif':
                    return 'btn-image-type ';

                case 'pdf':
                    return 'btn-file-type ';

                case 'doc':
                case 'docx':
                    return 'btn-doc-type ';

                case 'ppt':
                case 'pptx':
                    return 'btn-doc-type ';

                case 'xls':
                case 'xlx':
                    return 'btn-doc-type ';

                case 'cda':
                case 'mp3':
                case 'oga':
                    return 'btn-audio-type ';

                case 'mov':
                case 'mpeg':
                case 'mkv':
                case 'ogv':
                case 'webm':
                case '3gp':
                    return 'btn-video-type ';

                default:
                    return 'btn-file-type ';
            }
        },
        playAudio(fileId) {
            const name = 'audio-file-' + fileId;
            this.$refs[name][0].play();
            // Todo: feature request add stop button
        },

        previewFile(file) {
            this.$root.$refs.filePreview.show(file);
        },
    },
};
</script>

<style scoped lang="scss">
.explanation {
    .explanation-text {
        display: inline-block;
        width: 100%;
    }

    .component-title {
        flex: 1 0 100%;
        margin-bottom: map-get($grid-gutter-spacing, 'twenty-one');
    }

    :first-child {
        margin-top: 0;
    }
}

.images {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    align-items: center;

    .objectcontain {
        object-fit: contain !important;
    }

    .explanation-image {
        flex: 1 0 100%;
        object-fit: cover;
        object-position: top center;
        border-radius: $border-radius-content;
        height: 350px;
        max-width: 100%;

        &:not(:last-child) {
            margin-bottom: map-get($grid-gutter-spacing, 'fifteen');
        }

        &:hover {
            cursor: pointer;
            filter: brightness(70%);
        }
    }
}

.explanation-images {
    position: relative;

    .remaining-images {
        color: $white;
        font-size: 5rem;
        position: absolute;
        right: 0;
        bottom: calc(175px - 40px);
        left: calc(50% - 40px);
        line-height: 1;
        display: block;
        width: auto;
        text-shadow: 3px 3px $black;
        font-weight: $font-weight-bold;

        &:hover {
            cursor: pointer;
        }
    }
}

.explanation-video-file {
    border-radius: $border-radius-content;
}

.explanation-attachment-files,
.explanation-audio-files {
    .file {
        display: flex;
        justify-content: flex-start;
        align-content: center;
        font-size: 1.3125rem;

        .icon {
            align-self: center;
            padding: 10px;
            background: $secondary-background-color;
            border-radius: $border-radius-content;
            color: $primary;
        }

        .btn-preview-attachment-file {
            margin-left: map-get($grid-gutter-spacing, 'ten');
        }

        .title {
            font-size: $default-font-size;
            font-family: $headings-font-family;
            font-weight: $font-weight-bold;
            margin-left: map-get($grid-gutter-spacing, 'ten');
            margin-right: map-get($grid-gutter-spacing, 'ten');
            align-self: center;
            word-break: break-word;

            .file-size {
                font-size: 0.75rem;
                font-weight: $font-weight-normal;
            }
        }

        .download-file {
            display: flex;
            align-items: center;
            align-self: center;
            margin-left: auto;

            .btn-file-download {
                font-size: 1.3125rem;
                &:before {
                    margin-right: 0;
                }
            }
        }

        &:not(:last-child) {
            margin-bottom: map-get($grid-gutter-spacing, 'fifteen');
        }
    }
}

.explanation-audio-file {
    line-height: 1;

    .btn-audio,
    &.icon {
        display: none;
    }

    .audio-controls ::v-deep {
        height: fit-content;

        &,
        audio,
        .title {
            width: 100%;
        }

        audio {
            max-width: 400px;
        }

        .title {
            display: flex;
            flex-direction: row;
            flex-wrap: wrap;
            justify-content: space-between;
            align-items: flex-start;
            max-width: 100%;
            margin-left: 0;

            .name {
                width: calc(100% - 40px);
            }

            .btn-remove-audio-file {
                font-size: 1.3125rem;
            }
        }
    }
}

@media (min-width: map-get($grid-breakpoints, 'md')) {
    .explanation-images {
        .images {
            gap: 30px;
            justify-content: space-between;

            .explanation-image {
                width: calc(50% - 15px);
                flex: 0 0 auto;
                height: 200px;

                &:last-child:is(:nth-child(odd)) {
                    width: 100%;
                }

                &:not(:last-child) {
                    margin-bottom: 0;
                }
            }
        }

        .remaining-images {
            bottom: calc(100px - 40px);
            left: calc(50% + 55px);
        }
    }

    .explanation-audio-files,
    .explanation-attachment-files {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        flex-wrap: wrap;

        .file {
            flex: 1 0 calc(50% - 15px);
            max-width: calc(50% - 15px);

            &:not(:last-child) {
                margin-bottom: 0;
            }

            &:nth-child(odd) {
                margin-right: map-get($grid-gutter-spacing, 'fifteen');
            }

            &:not(:nth-last-child(1)):not(:nth-last-child(2)) {
                margin-bottom: map-get($grid-gutter-spacing, 'fifteen');
            }
        }
    }

    .explanation-audio-files {
        flex-direction: column;

        .file {
            flex: 1 0 100%;
            max-width: 100%;
        }
    }
}

@supports (-webkit-touch-callout: none) {
    /* CSS specific to iOS devices */

    .explanation-images {
        .images {
            .explanation-image:not(:last-child) {
                height: 100%;
            }
        }
    }
}

@media (min-width: map-get($grid-breakpoints, 'lg')) {
    //Due to weird issue in Safari where code below is not being executed!
    .explanation-images {
        .images:not(.imagescontain) {
            .explanation-image {
                &:not(:last-child),
                &:last-child {
                    height: 100% !important;
                }
            }
        }
    }

    .explanation-images {
        .imagescontain {
            grid-auto-rows: auto !important;
        }

        .images {
            display: grid;
            grid-template-columns: repeat(4, 1fr);
            grid-auto-rows: 170px;
            gap: 15px;

            .explanation-image {
                height: auto;
                max-height: 100%;
                width: 100%;
                object-fit: cover;

                &:last-child:is(:nth-child(odd)) {
                    height: 100%;
                }
            }
        }

        .remaining-images {
            bottom: calc(125px - 50px);
            left: calc(100% - 100px);
        }
    }

    //Explanation-images Images grid
    .explanation-image:first-child:nth-last-child(1) {
        grid-row: 1 / 3;
        grid-column: 1 / -1;
    }

    .explanation-image:first-child:nth-last-child(2),
    .explanation-image:first-child:nth-last-child(3),
    .explanation-image:first-child:nth-last-child(4),
    .explanation-image:first-child:nth-last-child(5),
    .explanation-image:first-child:nth-last-child(6),
    .explanation-image:first-child:nth-last-child(7),
    .explanation-image:first-child:nth-last-child(8) {
        grid-row: 1 / 3;
        grid-column: 1 / 3;
    }

    .explanation-image:first-child:nth-last-child(2) ~ .explanation-image {
        grid-row: 3 / -1;
        grid-column: 1 / 3;
    }

    .explanation-image:first-child:nth-last-child(2) ~ .explanation-image:last-child {
        grid-column: 3 / -1;
    }

    .explanation-image:first-child:nth-last-child(3) ~ .explanation-image,
    .explanation-image:first-child:nth-last-child(4) ~ .explanation-image {
        grid-column: 3 / -1;
    }

    .explanation-image:first-child:nth-last-child(4) ~ .explanation-image:last-child {
        grid-column: 1 / -1;
    }

    .explanation-image:first-child:nth-last-child(6) ~ .explanation-image:nth-child(4),
    .explanation-image:first-child:nth-last-child(6) ~ .explanation-image:nth-child(5),
    .explanation-image:first-child:nth-last-child(7) ~ .explanation-image:nth-child(4),
    .explanation-image:first-child:nth-last-child(7) ~ .explanation-image:nth-child(5),
    .explanation-image:first-child:nth-last-child(8) ~ .explanation-image:nth-child(4) {
        grid-row: 2 / 4;
    }

    .explanation-image:first-child:nth-last-child(6) ~ .explanation-image:last-child {
        grid-column: 1 / 3;
    }
}

@media (min-width: map-get($grid-breakpoints, 'xl')) {
    .explanation-images {
        .imagescontain {
            grid-auto-rows: auto !important;
        }

        .images {
            grid-auto-rows: 250px;
        }

        .remaining-images {
            bottom: calc(125px - 50px);
            left: calc(100% - 125px - 55px);
        }
    }

    .explanation-audio-files {
        flex-direction: row;

        .file {
            width: calc(50% - 15px);
            flex: 0 0 calc(50% - 15px);
        }

        .btn-audio.icon {
            display: flex;
            align-self: flex-start;
        }

        .audio-controls {
            width: calc(100% - 65px);
            align-self: flex-start;
            margin-left: map-get($grid-gutter-spacing, 'fifteen');
        }
    }
}

//Ipad landscape Queries
/*iPad mini 1, iPad 1 and iPad 2*/
@media only screen and (min-device-width: 768px) and (max-device-width: 1024px) and (-webkit-min-device-pixel-ratio: 1) and (orientation: landscape) {
    .explanation-images {
        .images.imagescontain {
            img.explanation-image:last-child {
                height: auto;
            }
        }
    }
}

/*iPad mini 2, iPad mini 3, iPad mini 4, iPad 3, iPad 4, iPad Air and iPad Air 2*/
@media only screen and (min-device-width: 768px) and (max-device-width: 1024px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: landscape) {
    .explanation-images {
        .images.imagescontain {
            img.explanation-image:last-child {
                height: auto;
            }
        }
    }
}

/*iPad Pro*/
@media only screen and (min-device-width: 1024px) and (max-device-width: 1366px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: landscape) {
    .explanation-images {
        .images.imagescontain {
            img.explanation-image:last-child {
                height: auto;
            }
        }
    }
}

/*   Safari 10.1+   */
@media not all and (min-resolution: 0.001dpcm) {
    .explanation-images {
        .images.imagescontain {
            img.explanation-image:last-child {
                height: auto;
            }
        }
    }
}
</style>
